// shared/brand.js
// Single source of truth for brand colors and WhatsApp config.

export const brand = {
  primary: "#B1336E",
  accentGold: "#E6B43C",
  accentGreen: "#67A43C",
  ink: "#1D1420",
  muted: "#6F6573",
  bg: "#FFF8FB",
  surface: "#FFFFFF",
  line: "#EBDCE5",
  plum: "#5A2045",
};

export const WA_NUMBER = "51977689676";
export const WA_MSG = encodeURIComponent("Hola Fast Max, quisiera más información.");
export const WA_HREF = `https://wa.me/${WA_NUMBER}?text=${WA_MSG}`;

export const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.18 },
  transition: { duration: 0.5, ease: "easeOut" },
};
